import { CATALOG_EVENT_KINDS } from '@steado/admin-contract/catalog-history';
import { z } from 'zod';

/** The windows the Date filter offers, and how far back each reaches. */
export const CATALOG_WINDOWS = ['7d', 'today', '30d', 'all'] as const;
export type CatalogWindow = (typeof CATALOG_WINDOWS)[number];

/**
 * Every filter, and the event open on the right, live in the URL: "what Riya
 * pushed this week" and "this batch" are links someone can send, and a food's
 * History opens a batch here by its key.
 */
export const catalogChangesSearchSchema = z.object({
  kind: z.enum(CATALOG_EVENT_KINDS).optional().catch(undefined),
  actor: z
    .union([z.string().uuid(), z.literal('system')])
    .optional()
    .catch(undefined),
  window: z.enum(CATALOG_WINDOWS).optional().catch(undefined),
  q: z.string().trim().min(1).max(96).optional().catch(undefined),
  /** The open event: a batch id, or `change:<id>`. */
  event: z.string().min(1).max(64).optional().catch(undefined),
});

export type CatalogChangesSearch = z.infer<typeof catalogChangesSearchSchema>;

/** When the window starts, as the API's `since`. Midnight local for Today. */
export function sinceOf(window: CatalogWindow, now: Date = new Date()): string | undefined {
  switch (window) {
    case 'today':
      return new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString();
    case '7d':
      return new Date(now.getTime() - 7 * 86_400_000).toISOString();
    case '30d':
      return new Date(now.getTime() - 30 * 86_400_000).toISOString();
    case 'all':
      return undefined;
  }
}
